module.exports = __webpack_public_path__ + "img/sphere.2d3dbd54.svg";